(function () {
  'use strict';

  angular
    .module('bidding')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('bidding', {
        url: '/bidding',
        sticky: true,
        views:	{
        	"biddingView": {		templateUrl: 'bidding/views/bidding.tpl.html',
        				controller: 'BiddingCtrl',
        				controllerAs: 'bidding'
        			}
        	}
      });
  }
}());
